<template>
  <div
    v-if="$login.can('accounts.create')"
    class="accounts-create"
  >
    <page-header header="Create Account" />
    <account-form
      ref="form"
      v-model="data"
      @save-success="created"
    />
  </div>
</template>

<script>
import {successNotification} from '@/notifications'
import AccountForm from '@/views/accounts/Form'

export default {
  components: {
    AccountForm,
  },

  metaInfo () {
    return {
      title: 'Create Account',
    }
  },

  data () {
    return {
      data: {
        name: null,
        parent_account_id: null,
        parent_account: null,
        is_mifid: false,
        logo: null,
        logo_url: null,
        account_type_id: null,
        account_type: null,
        website: null,
        children: [],
        address: {},
      },
      loading: false,
    }
  },

  methods: {
    created (response) {
      const msg = `Successfully created ${response.data.data.name}`

      this.$notify(successNotification(msg))
      this.$router.replace({name: 'accounts.view', params: {accountId: response.data.data.id}})
    },
  },
}
</script>
